import { createSlice } from '@reduxjs/toolkit';
import { resetStorage } from '@app/util/cache';

const slice = createSlice({
  name: 'auth',
  initialState: { user: null, token: null },
  reducers: {
    setCredentials: (state, { payload: { user, token } }) => {
      state.user = user;
      state.token = token;
    },
    logout: (state) => {
      state.user = undefined;
      state.token = undefined;
      setTimeout(() => resetStorage(), 300);
    },
    clearData: (state) => {
      state.user = undefined;
      state.token = undefined;
    },
    setCurrentUser: (state, { payload: user }) => {
      state.user = user;
    },
  },
});

export const {
  setCredentials,
  logout,
  setCurrentUser,
  setProfilePicture,
  clearData,
} = slice.actions;

export default slice.reducer;

export const selectCurrentAuth = (state) => state.auth;
